export default __webpack_public_path__ + "def571ea27e5e51d224eb464c9f562c8.svg";